import React from "react"
import PropTypes from "prop-types"
import { Icon as DSIcon } from "quorumdesign"
import Tooltip from "app/static/frontend/components/Tooltip"
import sortTypes, { reverseSortDirection } from "sheets/sort-types"
import { sortWarningText } from "sheets/components/helpTexts"
const ResourceTableColumnSortingIndicator =
({
    canSort,
    columnIndex,
    columnId,
    sorting,
    id,
    sortByColumnAtIndex,
    sortType,
    clearSort,
    defaultSortingType,
    canSetDefaultSort,
    isDefaultSorting,
    toggleDefaultSortOnColumn,
}) => (
    sorting ? (
        <div className="rt-column-sorting">
            { canSetDefaultSort ? (
                <Tooltip label={isDefaultSorting && defaultSortingType === sortType ?
                    'Click to unpin this sort (remove default sorting)' :
                    'Click to pin this sort (sheet will be sorted like this by default)'
                }>
                    <div className={isDefaultSorting && defaultSortingType === sortType ? 'selected default-sort' : 'default-sort'}>
                        <DSIcon
                            icon="thumbtack"
                            iconFamily="fal"
                            onClick={() => {
                                toggleDefaultSortOnColumn(
                                    id,
                                    columnId,
                                    isDefaultSorting && defaultSortingType === sortType  ? 0 : sortType
                                )
                            }}
                        />
                    </div>
                </Tooltip>
            ) : '' }
            <Tooltip label="Click to Reverse Sort">
                <div className={"column-icon-active"}>
                    <DSIcon
                        dataCy="column-reverse-sort"
                        icon={sortType === sortTypes.ASC
                            ? "sort-amount-up" : "sort-amount-down"
                        }
                        iconFamily="fal"
                        onClick={() =>
                            sortByColumnAtIndex(
                                id,
                                columnIndex,
                                reverseSortDirection(sortType)
                            )
                        }
                    />
                </div>
            </Tooltip>
            <Tooltip label="Click to Clear Sorting">
                <div className={"column-icon-active"}>
                    <DSIcon
                        dataCy="clear-sorting"
                        icon="times-circle"
                        iconFamily="fal"
                        onClick={() => clearSort(id)}
                    />
                </div>
            </Tooltip>
        </div>
    ) : (
        <Tooltip
            label={canSort ? "Sort" : sortWarningText}
        >
            <div
                className={"column-icon"}
                data-cy="column-sort"
            >
                <DSIcon
                    dataCy="column-sort"
                    disabled={canSort}
                    icon="sort-alt"
                    iconFamily="fal"
                    onClick={() => (canSort ? sortByColumnAtIndex(id, columnIndex, sortTypes.DESC) : null)}
                />
            </div>
        </Tooltip>
    )
)

ResourceTableColumnSortingIndicator.propTypes = {
    columnIndex: PropTypes.number.isRequired,
    id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    clearSort: PropTypes.func.isRequired,
}

export default ResourceTableColumnSortingIndicator
